var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"mb-4"},[_vm._v("Gestione mappatura nazioni")]),_c('div',{attrs:{"id":"mappingNazioneGrid"}})])}]

export { render, staticRenderFns }